import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CapturedPhoto from './CapturedPhoto';
import CapturedPhotoCheckpoint from './CapturedPhotoCheckpoint';
import LiveCamera from './LiveCamera';
import captureDeviceStepSelector from '../../../selectors/idverification/CaptureDeviceStepSelector';

import styles from './capturedevice.scss';
import { t } from '../../../services/i18nService';

const CaptureDeviceStep = (props) => {
    const {
        isHardwareAccessGranted,
        stream,
        checkpointPending,
        onPhotoCaptured,
        children,
        onNext } = props;

    const [blobPhoto, setBlobPhoto] = useState(null);

    const onPhoto = (photo) => {
        setBlobPhoto(photo);
        onPhotoCaptured(photo);
    };

    const getCameraComponent = () => {
        if (isHardwareAccessGranted) {
            return (<LiveCamera
                stream={stream}
                disabled={checkpointPending}
                alreadyCaptured={blobPhoto !== null}
                onPhoto={onPhoto}
            >
                {children}
            </LiveCamera>);
        }

        return (<div className={`${styles.streamPlaceholder}`}>
            <div className={`${styles.capturedPhoto} ${styles.placeholder}`}>
                <div className={styles.placeholderWrapper}>
                    <span className={styles.loadingLabel}>
                        {t('idVerification.captureDevice.loading')}
                    </span>
                </div>
            </div>
        </div>);
    };

    return (
        <div className={styles.captureDeviceStep}>
            { getCameraComponent() }
            <div className={styles.capturedPhotoCheckpoint}>
                <CapturedPhoto photo={blobPhoto} />
                <CapturedPhotoCheckpoint onNext={onNext} />
            </div>
        </div>
    );
};

CaptureDeviceStep.propTypes = {
    checkpointPending: PropTypes.bool,
    children: PropTypes.node,
    isHardwareAccessGranted: PropTypes.bool.isRequired,
    onNext: PropTypes.func.isRequired,
    onPhotoCaptured: PropTypes.func.isRequired,
    stream: PropTypes.object,
};

const mapStateToProps = state => captureDeviceStepSelector.selectProps(state);
export default connect(mapStateToProps)(CaptureDeviceStep);
